// @ts-nocheck
import React from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import { setRecaptchaV2Token } from 'slices/recaptchaSlice';
import type { AppRouteProps } from 'src/types/app'

type RecaptchaV2WrapperProps = Partial <AppRouteProps> & { services: any };
const ENABLE_RECAPTCHA = import.meta.env.VITE_ENABLE_RECAPTCHA !== 'false'

// Global state to track if reCAPTCHA has been rendered
let globalRecaptchaRendered = false
let globalRecaptchaInstanceId = 0

// Function to reset global state (useful for testing or page refreshes)
export const resetRecaptchaGlobalState = () => {
  globalRecaptchaRendered = false
  globalRecaptchaInstanceId = 0
}

@connect(({ recaptcha }) => ({
  recaptcha
}), {
  setRecaptchaV2Token,
})

export default class RecaptchaV2Wrapper extends React.Component<RecaptchaV2WrapperProps> {

  state = {
    rendered: false,
    instanceId: ++globalRecaptchaInstanceId,
  }

  isRecaptchaRendered = (containerId: string) => {
    const container = document.getElementById(containerId);
    return container && container.hasChildNodes();
  }

  renderRecaptcha = () => {
    const { setRecaptchaV2Token, recaptcha, services } = this.props
    const containerId = `recaptcha-wrapper-${this.state.instanceId}`
    
    if (this.isRecaptchaRendered(containerId)) {
      console.log('Recaptcha already rendered, skipping', { instanceId: this.state.instanceId, globalRendered: globalRecaptchaRendered })
      return
    }
    
    try {
      window.grecaptcha.render(containerId, {
        sitekey : services.googleRecaptcha_v2,
        callback: () => {
          console.log('recaptcha successful')
          const res = window.grecaptcha.getResponse()
          setRecaptchaV2Token(res)
        },
        'expired-callback': () => {
          if (!recaptcha.v2TokenValidated) {
            setRecaptchaV2Token('')
          }
          console.log('recaptcha expired')
        },
        'error-callback':  () => {
          if (!recaptcha.v2TokenValidated) {
            setRecaptchaV2Token('')
          }
          console.log('recaptcha error')
        },
      })
      // globalRecaptchaRendered = true
      this.setState({ rendered: true })
    } catch (e) {
      console.log('error rendering recaptcha', e)
    }
  }

  componentDidUpdate(prevProps: Readonly<RecaptchaV2WrapperProps>): void {
    const { recaptcha } = this.props
    if (recaptcha.mode === 'v2' && recaptcha.ready && window.grecaptcha && typeof window.grecaptcha.render === 'function' && !this.state.rendered && !globalRecaptchaRendered) {
      this.renderRecaptcha()   
    }
  }

  componentDidMount(): void {
    const { recaptcha } = this.props
    if (recaptcha.mode === 'v2' && recaptcha.ready && window.grecaptcha && typeof window.grecaptcha.render === 'function' && !this.state.rendered && !globalRecaptchaRendered) {
      this.renderRecaptcha()
    }
  }

  render() {
    const { recaptcha, services } = this.props
    const containerId = `recaptcha-wrapper-${this.state.instanceId}`
    
    return (recaptcha && ENABLE_RECAPTCHA) ? (
      <div 
        id={containerId}
        className='my1 g-recaptcha'
        data-sitekey={services.googleRecaptcha_v2}
        style={(recaptcha.ready && (recaptcha.mode === 'v2') && !recaptcha.v2TokenValidated) ? {display: 'inline-block', marginLeft: 'auto', marginRight: 'auto'} : {display: 'none'}}
      />
    ) : null
  }
}